/**
 * Dashed, full-width "escape hatch" tile that routes back to an earlier intake
 * step when none of the listed options fit. Used as the final tile in the
 * workflow, problem-set, and metrics steps. Clicking it opens the go-back
 * confirmation modal (the navigation is destructive — progress is lost).
 */

export interface BackTileProps {
  title: string;
  description: string;
  onClick: () => void;
}

export function BackTile({ title, description, onClick }: BackTileProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "flex w-full flex-col items-start gap-0.5 text-left",
        "rounded-[6px] border border-dashed border-(--border-default) bg-transparent px-[14px] py-3",
        "cursor-pointer font-[family-name:var(--font-body)]",
        "transition-colors duration-150 hover:border-(--border-strong) hover:bg-(--bg-sky)",
      ].join(" ")}
    >
      <span className="block text-[14px] font-medium text-(--fg-primary)">
        {title}
      </span>
      <span className="block text-[12px] leading-[1.45] text-(--fg-muted)">
        {description}
      </span>
    </button>
  );
}
